import script from "./SelfArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./SelfArticle.vue?vue&type=script&setup=true&lang=js"

import "./SelfArticle.vue?vue&type=style&index=0&id=5111e029&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5111e029"]])

export default __exports__